module.exports = __webpack_public_path__ + "img/收货ico.dbc2ebe5.png";